import React from 'react';

const cx = (...v) => v.filter(Boolean).join(' ');

export default function PageHeader({ eyebrow, title, subtitle, action = null, className = '' }) {
  return (
    <header className={cx('mb-4 flex flex-wrap items-start justify-between gap-3', className)}>
      <div>
        {eyebrow ? <p className="cc-text-subtle text-[10px] font-semibold uppercase tracking-[0.18em]">{eyebrow}</p> : null}
        <h1 className="cc-text-primary mt-1 text-2xl font-semibold tracking-tight md:text-3xl">{title}</h1>
        {subtitle ? <p className="cc-text-secondary mt-1 text-sm">{subtitle}</p> : null}
      </div>
      {action}
    </header>
  );
}
